var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormContainer, TopInputs, FormTitle } from './styles';
import { REQUIRED, PERSONAL_DETAILS, ADDRESS, ADDRESS_KEY, PHONE_KEY, } from 'src/Utils/constants';
import { InputComponent } from '../Common';
var Form = function (_a) {
    var inputs = _a.inputs, formData = _a.formData, setFormData = _a.setFormData, errors = _a.errors, disabled = _a.disabled;
    return (React.createElement(FormContainer, null,
        React.createElement(TopInputs, null,
            React.createElement(FormTitle, null, PERSONAL_DETAILS),
            inputs.map(function (_a, index) {
                var key = _a.key, label = _a.label;
                return key !== ADDRESS_KEY && (React.createElement(InputComponent, { key: index + key, disabled: disabled ? disabled : false, type: key, data: formData[key], error: errors, label: label + " " + (key === ADDRESS || key === PHONE_KEY ? '' : REQUIRED), placeHolder: label, onChangeFunction: function (e) {
                        e.persist();
                        setFormData(function (prevState) {
                            var _a;
                            return (__assign(__assign({}, prevState), (_a = {}, _a[key] = e.target.value, _a)));
                        });
                    } }));
            }))));
};
export default Form;
